import { useState } from "react";
import { Download, FileBadge } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

export const ClientPacketList = ({ packets }) => {
  const [error, setError] = useState("");
  if (!packets?.length) return null;
  async function open(packetId) {
    try {
      const response = await api.get(`/compliance/clearance-packets/${packetId}/download-link`);
      window.open(`${process.env.REACT_APP_BACKEND_URL}${response.data.path}`, "_blank", "noopener");
    } catch (requestError) {
      setError(formatApiError(requestError));
    }
  }
  return (
    <section className="client-packet-section" data-testid="client-clearance-packets">
      <div className="section-heading">
        <div>
          <h2><FileBadge size={17} /> Clearance packets</h2>
          <p>One-page clearance summaries TAG has shared for your placed providers. Source documents are never included.</p>
        </div>
      </div>
      {error && <p className="form-message error-message">{error}</p>}
      <ul className="clearance-packet-list">
        {packets.map((packet) => (
          <li key={packet.id} data-testid={`client-packet-${packet.id}`}>
            <div>
              <strong>{packet.provider_name}</strong>
              <small>{packet.provider_role} · shared {new Date(packet.portal_visible_at).toLocaleDateString()} · generated {new Date(packet.generated_at).toLocaleDateString()}</small>
            </div>
            <button type="button" className="button button-secondary" data-testid={`client-download-packet-${packet.id}`} onClick={() => open(packet.id)}><Download size={14} /> Download PDF</button>
          </li>
        ))}
      </ul>
    </section>
  );
};
